import * as React from 'react';
import { IItemClickParams, IMultiSuggestResult, IMessageInfo } from '@cian/geosuggest-widget';
import { TPlacement } from '@cian/ui-kit';
import {
  IFormFieldUI,
  IFormFieldWithLabel,
  IFormFieldErrorMessage,
  IFormFieldValue,
  INewbuildingSectionItem,
} from 'shared/mf-my-home/types/formFields';

/**
 * Интерфейсы пропсов отдельных фильтров, приходящих в виджет из места использования
 * */
export interface IBaseFilterProps<T> {
  /** Значение фильтра */
  value: T;
  /** Обработка изменения значения фильтра */
  onValueChange(value: T): void;
}

export interface IWithClassName {
  className?: string;
}

export interface IWithUnit {
  unit?: string;
}

/** Кол-во комнат */
export enum EFlatRoomCounts {
  Studio = 9,
  OneRoom = 1,
  TwoRoom = 2,
  ThreeRoom = 3,
  FourRoom = 4,
}

/** Пропсы для фильтра "Кол-во комнат" */
export type TRoomsCountSelectorProps<V> = IFormFieldUI<V> & IFormFieldWithLabel & IFormFieldErrorMessage;

/** Пропсы для фильтра "Площадь" */
export interface IAreaInputProps extends IBaseFilterProps<string> {
  /** Единицы измерения  */
  unit?: string;
  /** Текст для тултипа с ошибкой */
  errorMessage: string;
  /** Коллбэк по событию blur в инпуте */
  onBlur?(): void;
  shouldShowUnit?: boolean;
  /** Текст плейсхолдера для инпутов */
  placeholder?: string;
}

/** Пропсы для фильтра "Адрес" */
export interface IAddressInputProps extends IBaseFilterProps<string> {
  addressGeoSuggest: {
    isFetching: boolean;
    error?: IMessageInfo;
    suggestData?: IMultiSuggestResult;
  };
  /** Текст для тултипа с ошибкой */
  errorMessage: string;
  placeholder: string;
  onInputTagClick(e: React.MouseEvent<HTMLElement>): void;
  onItemClick(params: IItemClickParams): void;
}

/** Пропсы для фильтра Квартира */
export interface IRoomNumberInputProps extends IBaseFilterProps<string> {
  isRoomSuggestSuccess: boolean;
  errorMessage: string;
  placeholder?: string;
  onBlur?(): void;
}

/** Пропсы для фильтров, обогащенные базовыми пропсами */
export type TAreaInputComponentProps = IAreaInputProps & IWithClassName & IWithUnit;

export type TAddressInputComponentProps = IAddressInputProps & IWithClassName;

export type TRoomsCountSelectorComponentProps<V = string | number | null> = TRoomsCountSelectorProps<V> &
  IWithClassName & { placement?: TPlacement };

export const dropdownSeparator = Symbol();

export type TDropdownSeparator = typeof dropdownSeparator;

export interface IDropdownFilterUI<V> extends Omit<IFormFieldUI<V>, 'values'> {
  values: Array<IFormFieldValue<NonNullable<V>>>;
}

export interface IDropdownFilterWithSeparatorsUI<V> extends Omit<IFormFieldUI<V>, 'values'> {
  values: Array<IFormFieldValue<NonNullable<V>> | IFormFieldValue<TDropdownSeparator>>;
}

export interface ISwitchComponentProps {
  isChecked: boolean;
  onChange: () => void;
}

export interface INewbuildingSectionProps {
  newbuildingName: string;
  selectedSection?: number;
  newbuildingSections: INewbuildingSectionItem[];
  onItemChange: (section: INewbuildingSectionItem['value']) => void;
  errorMessage: string;
}
